/* eslint-disable @typescript-eslint/no-var-requires */
const Login = require('./login.json');
const Home = require('./Home.json');

const messages = {
  en: {
    当前语言: 'English',
    即时通信: 'IM',
    即时通信IM: 'IM',
    社交娱乐: 'Entertaining & Socializing',
    腾讯云: 'Tencent Cloud',
    使用指引: 'User Guide',
    Login,
    Home,
  },
};

export default messages;
